import createReactComponent from '../createReactComponent';
var Ruler = createReactComponent('Ruler', [['path', {
  d: 'M16 2l6 6L8 22l-6-6L16 2',
  key: '1h8ycn'
}], ['path', {
  d: 'M7.5 10.5l2 2',
  key: 'wujm19'
}], ['path', {
  d: 'M10.5 7.5l2 2',
  key: 'a9dia5'
}], ['path', {
  d: 'M13.5 4.5l2 2',
  key: '6jm1xp'
}], ['path', {
  d: 'M4.5 13.5l2 2',
  key: '9ype3x'
}]]);
export default Ruler;